/** True when the URL host is an AWS endpoint, not a substring in the path/query. */
export function isAmazonS3Url(url: string | undefined): boolean {
  if (!url) return false;

  try {
    return new URL(url).hostname.endsWith(".amazonaws.com");
  } catch {
    return false;
  }
}
